import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCompareProducts,
  selectCompareProducts,
} from "../../redux/reducers/slice/common";
import withCompareCondition from "./compareHOC";
import CompareProductItem from "./item";
import "./style.scss";

const Compare = () => {
  const [isCollapse, setIsCollapse] = useState(false);
  const compareProducts = useSelector(selectCompareProducts);
  const dispatch = useDispatch();
  const [prevProductsLength, setPrevProductsLength] = useState(
    compareProducts.length
  );
  const collapse = () => {
    setIsCollapse(true);
  };
  const expand = () => {
    setIsCollapse(false);
  };

  const close = () => {
    dispatch(clearCompareProducts());
  };

  useEffect(() => {
    if (Array.isArray(compareProducts) && compareProducts.length) {
      const compareLst = document.querySelector(".compare-content");

      if (!compareLst) {
        console.log("compareLst is null");
        return;
      }

      if (compareProducts.length > prevProductsLength) {
        compareLst?.scrollTo({
          top: 0,
          left: compareLst.scrollWidth,
          behavior: "smooth",
        });
      }
    }

    setPrevProductsLength(compareProducts.length);
  }, [compareProducts]);

  return (
    <>
      {Array.isArray(compareProducts) && compareProducts.length ? (
        isCollapse ? (
          <div className="compare compare--collapse">
            <div className="compare-expand-button" onClick={expand}>
              <div className="compare-expand-button__icon">
                <img
                  src="https://kdstore.s3.ap-southeast-1.amazonaws.com/static/icons/icon_compare3-82.svg"
                  alt=""
                />
              </div>
              <span className="compare-expand-button__text main-content">
                So sánh ({compareProducts.length})
              </span>
            </div>
          </div>
        ) : (
          <div className="compare compare--expand">
            <div className="compare-content">
              {compareProducts.map((product: any, index: number) => (
                <CompareProductItem product={product} index={index} />
              ))}
              {compareProducts.length < 2 && (
                <CompareProductItem
                  product={null}
                  index={compareProducts.length}
                />
              )}
              {compareProducts.length < 3 && (
                <CompareProductItem
                  product={null}
                  index={compareProducts.length}
                />
              )}
            </div>
            <div className="compare-button-group">
              <button
                className="compare-collapse-button sub-title"
                onClick={collapse}>
                Thu gọn
              </button>
              <button
                className="compare-close-button sub-title"
                onClick={close}></button>
            </div>
          </div>
        )
      ) : null}
    </>
  );
};

export default withCompareCondition(Compare);
